import React, { useState, useEffect } from 'react';
import { FaEllipsisV } from 'react-icons/fa';
import { useNavigate } from 'react-router';
import ApiService, { initialAuthState } from '../../services/ApiService';

const Promocode = () => {
  const navigate = useNavigate();
  const [promocodes, setPromocodes] = useState([]);
  const [allPromocodes, setAllPromocodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    fetchPromocodes();
  }, []);

  const fetchPromocodes = async () => {
    try {
      const payload = {
        companyCode: initialAuthState.companyCode,
        unitCode: initialAuthState.unitCode,
      };
      const response = await ApiService.post('/promocode/getPromocodeDetails', payload);

      if (response.data) {
        setPromocodes(response.data);
        setAllPromocodes(response.data);
      } else {
        console.error('Invalid response format');
      }
    } catch (error) {
      console.error('Error fetching promocodes:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    const query = searchQuery.toLowerCase().trim();
    if (!query) {
      setPromocodes(allPromocodes);
      return;
    }
    const filtered = allPromocodes.filter(item =>
      item.promocode?.toLowerCase().includes(query)
    );
    setPromocodes(filtered);
  };

  const toggleDropdown = (id) => {
    setDropdownOpen(dropdownOpen === id ? null : id);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.dropdown-container')) setDropdownOpen(null);
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this promocode?')) return;

    try {
      await ApiService.post('/promocode/deletePromocodeDetails', {
        id,
        companyCode: initialAuthState.companyCode,
        unitCode: initialAuthState.unitCode,
      });
      alert('Promocode deleted successfully!');
      fetchPromocodes();
    } catch (error) {
      console.error('Error deleting promocode:', error);
      alert('Failed to delete promocode.');
    }
  };

  return (
    <div className="m-2">
      <div className="flex justify-between items-center py-4">
        <h2 className="text-2xl font-semibold text-gray-800">Promocodes</h2>
        <button
          className="bg-green-700 text-white px-4 py-2 rounded-md"
          onClick={() => navigate('/addEdit-promocode')}
        >
          Add Promocode
        </button>
      </div>

      <div className="flex mb-4">
        <input
          type="text"
          placeholder="Search by Promocode"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="h-12 flex-grow border border-gray-300 rounded-md px-3 shadow-sm"
        />
        <button
          onClick={handleSearch}
          className="h-12 px-6 bg-green-700 text-white rounded-md ml-2"
        >
          Search
        </button>
      </div>

      {loading ? (
        <p className="text-center text-gray-600">Loading...</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-300 rounded-lg">
            <thead>
              <tr className="border-b bg-blue-500 text-white text-left">
                <th className="px-4 py-3 text-sm font-bold">Promocode</th>
                <th className="px-4 py-3 text-sm font-bold">Discount</th>
                <th className="px-4 py-3 text-sm font-bold">Discount Type</th>
                <th className="px-4 py-3 text-sm font-bold">Min Order</th>
                <th className="px-4 py-3 text-sm font-bold">Max Discount</th>
                <th className="px-4 py-3 text-sm font-bold">Start Date</th>
                <th className="px-4 py-3 text-sm font-bold">End Date</th>
                <th className="px-4 py-3 text-sm font-bold">Users</th>
                <th className="px-4 py-3 text-sm font-bold">Status</th>
                <th className="px-4 py-3 text-sm font-bold">Action</th>
              </tr>
            </thead>
            <tbody>
              {promocodes.length > 0 ? (
                promocodes.map((item, idx) => (
                  <tr key={item.id} className={`border-b ${idx % 2 === 0 ? 'bg-gray-200' : 'bg-white'}`}>
                    <td className="px-4 py-3">{item.promocode}</td>
                    <td className="px-4 py-3">{item.discount}</td>
                    <td className="px-4 py-3">{item.discountType}</td>
                    <td className="px-4 py-3">{item.minOrderAmount ?? '-'}</td>
                    <td className="px-4 py-3">{item.maxDiscountAmount ?? '-'}</td>
                    <td className="px-4 py-3">{item.startDate ? new Date(item.startDate).toLocaleDateString() : '-'}</td>
                    <td className="px-4 py-3">{item.endDate ? new Date(item.endDate).toLocaleDateString() : '-'}</td>
                    <td className="px-4 py-3">{item.totalUsage ?? 0}</td>
                    <td className="px-4 py-3">{item.promoStatus}</td>
                    <td className="px-4 py-3 relative dropdown-container">
                      <button
                        onClick={(e) => { e.stopPropagation(); toggleDropdown(item.id); }}
                        className="p-2 bg-white rounded-md"
                      >
                        <FaEllipsisV className="text-gray-700" />
                      </button>
                      {dropdownOpen === item.id && (
                        <div className="absolute right-0 mt-2 bg-white shadow-lg border rounded-md min-w-[150px] z-50">
                          <ul className="text-left">
                            <li
                              className="p-2 hover:bg-gray-100 cursor-pointer"
                              onClick={() =>
                                navigate('/addEdit-promocode', { state: { editData: item } })
                              }
                            >
                              Edit
                            </li>
                            <li
                              className="p-2 hover:bg-gray-100 cursor-pointer"
                              onClick={() => handleDelete(item.id)}
                            >
                              Delete
                            </li>
                          </ul>
                        </div>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="text-center py-4">No Promocodes found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Promocode;